import * as Sentry from '@sentry/react';

import { AppEnvMap, AppEnvironment } from '@/core/app-env';

function normalizeError(error: unknown): Error {
  if (error instanceof Error) return error;
  if (error instanceof Response) {
    return new Error(
      `HTTP ${error.status} ${error.statusText}${error.url ? ` (${error.url})` : ''}`,
    );
  }
  let detail: string;
  try {
    detail = JSON.stringify(error);
  } catch {
    detail = String(error);
  }
  return new Error(`Non-Error thrown: ${detail}`);
}

/**
 * captureException on a non-Error (e.g. a fetch Response) produces useless
 * "[object Response]" events — normalize anything unknown before reporting.
 */
export function captureUnexpectedError(
  error: unknown,
  extra?: Record<string, unknown>,
) {
  Sentry.captureException(normalizeError(error), extra ? { extra } : undefined);
}

export function initSentry() {
  if (AppEnvMap.Env !== AppEnvironment.Prod) return;
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;
  Sentry.init({
    dsn,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
